import { useQuery } from "react-query";
import { getTemplate } from "../api";
import { useToken } from "./useToken";

export const useTemplate = (id) => {
  const { token } = useToken();
  return useQuery(`getTemplate:${id}`, () => getTemplate({ token, id }));
};
